import React from 'react';

interface Props { on: boolean; onChange: () => void; }

export const Toggle: React.FC<Props> = ({ on, onChange }) => (
  <button type="button" className={`toggle ${on ? 'on' : 'off'}`} onClick={onChange} />
);
